<template>
	<div class="uadsif09a" :class="[size, type]">
		<div v-show="isVisible" class="spinner">
			<div class="item bounce1"></div>
			<div class="item bounce2"></div>
			<div class="item bounce3"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "j-spinner",
	props: {
		type: {
			required: false,
			default: "dark",
			type: String
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					["xsmall", "small", "medium", "large", "xlarge"].includes(val)
				)
			}
		},
		delay: {
			type: Number,
			required: false,
			default: 300
		}
	},
	data() {
		return {
			isVisible: false
		}
	},
	mounted() {
		let timeout = setTimeout(() => (this.isVisible = true), this.delay)
	}
}
</script>

<style src="./index.css" scoped />
